"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Dropdown_1 = __importDefault(require("components/design-system/dropdown/Dropdown"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const renderMenuItems = (option, isSubMenu) => {
    return (react_1.default.createElement(Dropdown_1.default.MenuItems, { isParent: !isSubMenu, vPosition: isSubMenu ? 'relative' : undefined, position: isSubMenu ? 'right' : undefined, customClass: "w-[200px]" },
        react_1.default.createElement("span", { className: "px-[16px] py-[8px] typography-h100 text-n-600" }, option.name),
        react_1.default.createElement(react_1.default.Fragment, null, option.options?.map((option, index) => {
            return (react_1.default.createElement(Dropdown_1.default.MenuItem, { key: index, dataCy: `list-filter-${index}` },
                react_1.default.createElement("div", { className: "w-full flex justify-between" },
                    react_1.default.createElement("div", { className: "truncate" }, option.name),
                    (option.options || option.subMenuComponent) && (react_1.default.createElement("div", { className: "ml-[8px] flex items-center -mr-[8px]" },
                        option.badge && option.badge,
                        react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-arrow_right", size: 24, fillColor: "var(--n-600)", customClass: "arrow-dropright" })))),
                option.options && renderMenuItems(option, true),
                option.subMenuComponent && option.subMenuComponent));
        }))));
};
const MenuFilter = ({ menuOptions }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.default, { customClass: "mr-[16px]" },
            react_1.default.createElement(Dropdown_1.default.Trigger, { customClass: "flex" },
                react_1.default.createElement(SVGIcon_1.default, { size: 16, iconName: "icon-filter_list", fillColor: 'var(--base-600)', dataCy: "advance-filter-icon" }),
                react_1.default.createElement("p", { className: "ml-[8px] text-base-600" }, (0, HelperUtils_1.getObjectiveLocale)('Filter'))),
            renderMenuItems(menuOptions))));
};
exports.default = MenuFilter;
